export function buildProjectUsersByLocalIdsQueryV1(workspaceId: number, projectId: number, localIds: string[])
{
	return {
		'$type': 'TCh.Domain.ProjectUsers.Queries.ProjectUsersByLocalIdsQueryV1, TCh.Domain.ProjectUsers',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'LocalIds': localIds
	}
}


export function buildProjectUsersByIdsQueryV1(workspaceId: number, projectId: number, projectUsersIds: number[])
{
	return {
		'$type': 'TCh.Domain.ProjectUsers.Queries.ProjectUsersByIdsQueryV1, TCh.Domain.ProjectUsers',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ProjectUsersIds': projectUsersIds
	}
}

export function buildPeoplePageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.ProjectUsers.Queries.PeoplePageQueryV1, TCh.Domain.ProjectUsers',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildProjectUserDependenciesQueryV1(workspaceId: number, projectId: number, projectUserId: number)
{
	return {
		'$type': 'TCh.Domain.ProjectUsers.Queries.ProjectUserDependenciesQueryV1, TCh.Domain.ProjectUsers',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ProjectUserId': projectUserId
	}
}

